<template>
  <div class="quiz-box">
    <div class="quiz-box-main">
      <ui-frame-bg v-if="subType !== 'schedule' && rounds && rounds.length !== 0" class="matchList-box" colorType="blue-light">
        <ul class="matchList">
          <!-- 局数标签 -->
          <li
            v-for="(match, key) in rounds"
            :key="key"
            :class="{ active: match.matchCode == subMatch }"
            @click="switchMatch(match.matchCode)"
          >
            <ui-frame-bg class="bg-active" colorType="yellow"></ui-frame-bg>
            <div class="label-box">
              <span class="label-shadow">{{ match.name }}</span>
              <span class="label-text">{{ match.name }}</span>
            </div>
          </li>
        </ul>
      </ui-frame-bg>
      
      <div class="quiz-list" v-if="quizList && quizList.length != 0">
        <!-- 竞猜内容 -->
        <card-container v-for="(item, key) in quizList" :key="key" :info="item">
          <all-teams v-if="item.stype == 1" :info="item" :list="item.teamList"></all-teams>
          <single-team-or-member v-if="item.type == 2 && item.stype == 2" :info="item"></single-team-or-member>
          <!-- 排行PK渲染层 -->
          <rankPK v-if="item.type == 3 && item.stype == 2" :info="item"></rankPK>
          <!-- 淘汰PK渲染层 -->
          <disusePK v-if="item.type == 4 && item.stype == 2" :info="item"></disusePK>
        </card-container>
        <quiz-coin />
      </div>
      <Interdict v-else tip="暂无竞猜内容">
        <quiz-coin />
      </Interdict>
    </div>
    <div class="quiz-box-tip">
      <i></i>
      <div class="label-box">
        <span class="label-shadow">参与竞猜可获得“竞猜币”，免费兑换「糖果」「赛事币」「占卜币」「缤纷补给箱钥匙」等奖励！</span>
        <span class="label-text">参与竞猜可获得“竞猜币”，免费兑换「糖果」「赛事币」「占卜币」「缤纷补给箱钥匙」等奖励！</span>
      </div>
    </div>
  </div>
</template>

<script>
import CardContainer from '@/views/quiz/layout/cardContainer';
import AllTeams from '@/views/quiz/type/allTeams';
import SingleTeamOrMember from '@/views/quiz/type/singleTeamOrMember';
import DisusePK from '@/views/quiz/type/disusePK';
import RankPK from '@/views/quiz/type/rankPK';
import uiFrameBg from "@/components/ui-frame-bg";
import Interdict from '@/components/interdict';
import QuizCoin from '@/views/quiz/layout/quizCoin';
// type 竞猜类别(1: 赛程竞猜，2: 实时竞猜，3: 排名PK，4: 淘汰PK)
// stype 竞猜子类别(1: 多项竞猜[队伍列表], 2: 单项竞猜[单个队伍/队员])

export default {
  inject: ["switchMatch", "switchSchedule"],
  components: {
    CardContainer,
    AllTeams,
    SingleTeamOrMember,
    DisusePK,
    RankPK,
    uiFrameBg,
    Interdict,
    QuizCoin
  },
  // provide() {
  //     return {
  //         displaySelect: this.displaySelect
  //     }
  // },
  props: {
    subType: {
      type: String,
      default: () => ''
    },
    rounds: {
      type: Array,
      default: () => []
    },
    subMatch: {
      type: [Number, String],
      default: () => 0
    },
    quizList: {
      type: Array,
      default: () => []
    },
    defaultScheduleID: {
      type: String,
      default: () => ''
    },
    quizSchedule: {
      type: Array,
      default: () => []
    },
    subSchedule: {
      type: Object,
      default: () => { }
    },
    // showSelect: {
    //     type: Boolean,
    //     default: () => {}
    // }

  },
  data() {
    return {
      showSelect: false
    }
  },
  methods: {
    displaySelect() {
      this.showSelect = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/quiz/layout/quizBox.scss";
</style>